module.exports = __webpack_public_path__ + "static/media/arrow-from-left.8f87bd00.svg";